module.exports = __webpack_public_path__ + "img/ko_arima5.26b95015.jpg";